<template>
  <div id="download-progres" class="mc-download">
    <div class="mc-download__header d-flex justify-content-between">
      <div class="d-flex">
        <h4>
          {{
            downloadVideoHistoriesInProgreess.length
              ? $t('videoHistory.widgetDownload.preparingDownload')
              : $t('videoHistory.widgetDownload.downloadFinish')
          }}
        </h4>
        <span
          v-if="loadingDownload"
          class="mx-2 spinner-border spinner-border-sm text-white"
        ></span>
      </div>
      <div>
        <i
          :style="{
            position: $store.state.vehicle.isLoadingDownloadVideoHistoriesWidget
              ? 'static'
              : undefined,
          }"
          class="mc-fa icon-fill_arrow-ios-up"
          @click="toggleDownload()"
        ></i>
        <i class="mc-fa icon-outline_close ms-2" @click="closeDownload()"></i>
      </div>
    </div>
    <div class="accordion mc-download__body" role="tablist">
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-1 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.complete') }} ({{
                downloadVideoHistoriesSuccess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-1"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesSuccess.length">
            <div
              v-for="(video, index) in downloadVideoHistoriesSuccess"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.vehicle.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                    )} - ${momentDMYH(
                      convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                    )}`"
                  >
                    {{ video.vehicle.licensePlate }} {{ video.convertedChannel }} -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                      )
                    }}
                    -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                      )
                    }}
                  </p>
                  <p>
                    <span>
                      {{ $t('videoHistory.widgetDownload.downloadTime') }}
                      {{ momentDMYH(video.downloadOn) }}
                    </span>
                  </p>
                </div>
              </div>
              <b-row class="mt-2 mc-download__list-item-button">
                <b-col md="6">
                  <b-button
                    class="w-100"
                    variant="outline-primary"
                    @click="handleClickShowVideo(video)"
                  >
                    <i class="mc-fa icon-outline_play-circle"></i>
                    {{ $t('videoHistory.widgetDownload.watchVideo') }}
                  </b-button>
                </b-col>
                <b-col md="6">
                  <a
                    v-if="isVideoDemo"
                    :href="video.url"
                    download
                    class="btn btn-primary mc-button__download-video-history"
                  >
                    <i class="mc-fa icon-outline_download" />
                    {{ $t('videoHistory.widgetDownload.download') }}
                  </a>
                  <b-button v-else variant="primary" class="w-100" @click="startDownload(video)">
                    <i class="mc-fa icon-outline_download"></i>
                    {{ $t('videoHistory.widgetDownload.download') }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadSuccess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div class="mc-download__info" header-tag="header" role="tab">
          <div v-b-toggle.download-2 class="d-flex justify-content-between">
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.running') }} ({{
                downloadVideoHistoriesInProgreess.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-2"
          ref="downloadInProgress"
          class="mc-download__list"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <template v-if="downloadVideoHistoriesInProgreess.length">
            <div
              v-for="(video, index) in downloadVideoHistoriesInProgreess"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.vehicle.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                    )} - ${momentDMYH(
                      convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                    )}`"
                  >
                    {{ video.vehicle.licensePlate }} {{ video.convertedChannel }} -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                      )
                    }}
                    -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                      )
                    }}
                  </p>
                  <p>
                    <span>
                      {{ $t('videoHistory.widgetDownload.downloadTime') }}
                      {{ momentDMYH(video.downloadOn) }}
                    </span>
                  </p>
                </div>
              </div>
              <b-progress :value="100" variant="secondary" :animated="true" class="mt-3" />
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadProcess') }}
            </p>
          </template>
        </b-collapse>
      </div>
      <div class="mc-download__body-wrapper">
        <div header-tag="header" role="tab" class="mc-download__info">
          <div v-b-toggle.download-3 class="d-flex justify-content-between">
            <!--  eslint-disable-next-line vue/singleline-html-element-content-newline -->
            <p class="blue-500">
              {{ $t('videoHistory.widgetDownload.stop') }} ({{
                downlaodVideoHistoriesFailed.length
              }})
            </p>
            <i class="mc-fa icon-fill_arrow-ios-down"></i>
          </div>
        </div>
        <b-collapse
          id="download-3"
          class="mc-download__list mc-download__list--fail"
          role="tabpanel"
          visible
          accordion="my-accordion"
        >
          <template v-if="downlaodVideoHistoriesFailed.length">
            <div
              v-for="(video, index) in downlaodVideoHistoriesFailed"
              :key="index"
              class="mc-download__list-item"
            >
              <div class="mc-download__list-item-wrapper d-flex">
                <i class="mc-fa icon-fill_videorecord"></i>
                <div class="mc-download__list-item-text">
                  <p
                    :title="`${video.vehicle.licensePlate} ${video.convertedChannel} - ${momentDMYH(
                      convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                    )} - ${momentDMYH(
                      convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                    )}`"
                  >
                    {{ video.vehicle.licensePlate }} {{ video.convertedChannel }} -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.startTime, video.vehicle.device.timezone)
                      )
                    }}
                    -
                    {{
                      momentDMYH(
                        convertUtcToLocalDate(video.endTime, video.vehicle.device.timezone)
                      )
                    }}
                  </p>
                  <p>
                    <span class="red-500">
                      <i class="mc-fa icon-fill_alert-triangle" />
                      {{ $t('videoHistory.widgetDownload.failedDownload') }}
                    </span>
                    <span> {{ momentDMYH(video.downloadOn) }}</span>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="text-center">
              {{ $t('global.action.noDownloadStop') }}
            </p>
          </template>
        </b-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import moment from 'moment'
moment.locale('id')

export default {
  mixins: [Helper, MixPanel],
  data() {
    return {
      downloadInProgressIds: [],
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    downloadPerItemActive() {
      return this.$store.state.vehicle.downloadVideoPerItemStatus
    },
    loadingDownload() {
      return this.$store.state.vehicle.isLoadingDownloadVideoHistoriesWidget
    },
    lastDownload() {
      return this.$store.state.vehicle.downloadVideoHistoriesLastDownload
    },
    downloadVideoHistories() {
      return this.$store.state.vehicle.downloadVideoHistoriesWidgetData
    },
    downloadVideoHistoriesInProgreess() {
      return this.downloadVideoHistories.filter((video) => video.status === 'I')
    },
    downlaodVideoHistoriesFailed() {
      return this.downloadVideoHistories.filter((video) =>
        this.downloadFailedIds.includes(video.downloadId)
      )
    },
    downloadVideoHistoriesSuccess() {
      if (this.isVideoDemo) {
        return this.$store.state.vehicle.downloadVideoHistoriesSuccessData
      }
      return this.downloadVideoHistories.filter((video) =>
        this.downloadSuccessIds.includes(video.downloadId)
      )
    },
    downloadSuccessIds() {
      return this.$store.state.vehicle.downloadVideoHistoriesSuccessData.map(
        (video) => video?.downloadId
      )
    },
    downloadFailedIds() {
      return this.$store.state.vehicle.downloadVideoHistoriesFailedData.map(
        (video) => video?.downloadId
      )
    },
    downloadVideoHistoriesFirstData() {
      return this.$store.state.vehicle.downloadVideoHistoriesFirstData
    },
    isVideoDemo() {
      const dataDemoVideoHistory = JSON.parse(
        this.getFeatureFlagData('vsms2_trackvision2_playback_demo_id').value
      )
      if (!this.$route.query?.vehicleId) {
        return null
      }
      return (
        process.env.NODE_ENV === 'production' &&
        Object.keys(dataDemoVideoHistory).includes(this.$route.query.vehicleId.toString())
      )
    },
  },
  watch: {
    downloadVideoHistoriesFirstData(downloadVideoHistoriesFirstData) {
      const isBsj = this.$store.state.vehicle.vehicleDetail.deviceName === 'bsj'
      const isJc = this.$store.state.vehicle.vehicleDetail.deviceName === 'jc'

      let _downloadPerItemActive = []
      if (this.downloadPerItemActive.length) {
        this.downloadPerItemActive.forEach((item) => {
          const [index, indexVideo] = item.split(':')
          const video = this.$store.state.vehicle.vehicleVideos[index].videos[indexVideo]
          const _video = video
          _video['startTime'] = this.getUtcDateFromLocalDate(
            video.startTime,
            this.$store.state.vehicle.deviceTimezone
          )
          if (isJc) {
            _video['endTime'] = this.getUtcDateFromLocalDate(
              moment(video.startTime).add(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss'),
              this.$store.state.vehicle.deviceTimezone
            )
          } else if (isBsj) {
            _video['endTime'] = this.getUtcDateFromLocalDate(
              video.endTime,
              this.$store.state.vehicle.deviceTimezone
            )
          }
          _downloadPerItemActive.push(_video)
        })
      }

      let downloadInput
      if (isBsj) {
        downloadInput = this.lastDownload.input.bsjInput
        downloadInput['channel'] =
          typeof downloadInput.channel === 'number'
            ? downloadInput.channel
            : parseInt(downloadInput.channel.slice(2))
      } else if (isJc) {
        downloadInput = this.lastDownload.input.jcInput
        downloadInput['channel'] = downloadInput.cameraPosition
      }

      const videoInRanges = downloadVideoHistoriesFirstData.filter((video) => {
        const isInRanges =
          this.isBetweenDate(video.startTime, downloadInput.startTime, downloadInput.endTime) ||
          this.isBetweenDate(video.endTime, downloadInput.startTime, downloadInput.endTime) ||
          (video.startTime === downloadInput.startTime &&
            video.endTime === downloadInput.endTime) ||
          this.checkVideoitemActiveInRanges(video, _downloadPerItemActive)

        return (
          video.vehicle.id === this.lastDownload.vehicleId &&
          video.channel === downloadInput.channel &&
          isInRanges
        )
      })

      let _downloadSuccess = []
      videoInRanges.forEach((video) => {
        if (video.status === 'S') {
          _downloadSuccess.push(video)
        }
      })
      const uniqueTime = []
      _downloadSuccess.forEach((video) => {
        if (!uniqueTime.includes(`${video.startTime} ${video.endTime}`)) {
          uniqueTime.push(`${video.startTime} ${video.endTime}`)
        }
      })
      let tempDownlaodSuccess = []
      for (let i = 0; i < uniqueTime.length; i++) {
        let added = false
        for (let j = 0; j < _downloadSuccess.length; j++) {
          if (added) break
          const [_startTime, _endTime] = uniqueTime[i].split(' ')
          const isVideoFound =
            _startTime === _downloadSuccess[j].startTime && _endTime === _downloadSuccess[j].endTime
          if (isVideoFound) {
            tempDownlaodSuccess.push(_downloadSuccess[j])
            added = true
          }
        }
      }

      const _inProgress = this.downloadVideoHistoriesInProgreess.filter((video) => {
        const isInRanges =
          this.isBetweenDate(video.startTime, downloadInput.startTime, downloadInput.endTime) ||
          this.isBetweenDate(video.endTime, downloadInput.startTime, downloadInput.endTime) ||
          (video.startTime === downloadInput.startTime &&
            video.endTime === downloadInput.endTime) ||
          this.checkVideoitemActiveInRanges(video, _downloadPerItemActive)

        return (
          video.vehicle.id === this.lastDownload.vehicleId &&
          video.channel === downloadInput.channel &&
          isInRanges
        )
      })

      // This variable to collect download success after comparing tempDownloadSuccess with _inProgress
      let generatedDownloadSuccess = []
      tempDownlaodSuccess.forEach((downloadSuccess) => {
        const isInProgress = _inProgress.some(
          (downloadInProgress) =>
            downloadSuccess.vehicle.id === downloadInProgress.vehicle.id &&
            downloadSuccess.channel === downloadInProgress.channel &&
            downloadSuccess.startTime === downloadInProgress.startTime &&
            downloadSuccess.endTime === downloadInProgress.endTime
        )
        if (!isInProgress) {
          generatedDownloadSuccess.push(downloadSuccess)
        }
      })

      this.$store.commit('vehicle/updateDownloadVideoHistoriesSuccessData', [
        ...this.$store.state.vehicle.downloadVideoHistoriesSuccessData,
        ...generatedDownloadSuccess,
      ])
    },
    async downloadVideoHistoriesInProgreess(videoHistoriesInProgress) {
      if (this.isVideoDemo) {
        if (!videoHistoriesInProgress.length) {
          this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
        }
        return
      }
      // Check progress video per item
      const _vehicleVideos = this.$store.state.vehicle.vehicleVideos
      this.$store.state.vehicle.downloadVideoPerItemStatus.forEach((indexKey) => {
        const [index, indexVideo] = indexKey.split(':')
        const _vehicleVideo = _vehicleVideos[index].videos[indexVideo]
        const _vehicleVideoItemInProgress = videoHistoriesInProgress.find(
          (data) =>
            data.vehicle.id === this.$store.state.vehicle.vehicleDetail.id &&
            this.formatDateToUtc(_vehicleVideo?.startTime) === data?.startTime
        )
        if (!_vehicleVideoItemInProgress) {
          this.$store.commit('vehicle/removeDownloadVideoPerItemStatus', [index, indexVideo])
        }
      })

      const downloadVideoHistoriesInProgressFirstDataIds =
        this.$store.state.vehicle.downloadVideoHistoriesInProgressFirstData.map(
          (video) => video.downloadId
        )

      downloadVideoHistoriesInProgressFirstDataIds.forEach((downloadId) => {
        const downloadVideo = this.downloadVideoHistories.find(
          (video) => video.downloadId === downloadId
        )
        const isDownloadSuccess = downloadVideo?.status === 'S'
        const isDownloadFailed = downloadVideo?.status === 'F'

        if (isDownloadSuccess && !this.downloadSuccessIds.includes(downloadId)) {
          this.$store.commit('vehicle/updateDownloadVideoHistoriesSuccessData', [
            ...this.$store.state.vehicle.downloadVideoHistoriesSuccessData,
            downloadVideo,
          ])
        }
        if (isDownloadFailed && !this.downloadFailedIds.includes(downloadId)) {
          this.$store.commit('vehicle/updateDownloadVideoHistoriesFailedData', [
            ...this.$store.state.vehicle.downloadVideoHistoriesFailedData,
            downloadVideo,
          ])
        }
      })
      if (videoHistoriesInProgress.length === 0) {
        this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
      }
      if (this.loadingDownload && videoHistoriesInProgress.length) {
        this.downloadInProgressIds = videoHistoriesInProgress.map((video) => video.downlaodId)
        await this.sleep(5000)
        this.fetchDownloadVideoHistories().then((dataVideoHistories) => {
          this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', dataVideoHistories)
        })
      }
    },
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async fetchDownloadVideoHistories() {
      try {
        const variables = {
          filter: {
            allUsers: false,
            startDate: this.formatDateToUtc(moment(new Date()).format('YYYY-MM-DD 00:00')),
            endDate: this.formatDateToUtc(this.now()),
            orderBy: JSON.stringify({ downloadOn: 'desc' }),
          },
        }
        const data = await this.$store.dispatch('vehicle/requestDownloadVideoHistories', variables)
        return data
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    toggleDownload() {
      var toggleDownload = document.getElementById('download-progres')
      toggleDownload.classList.toggle('show-body')
    },

    closeDownload() {
      document.body.classList.remove('mc-widget-download')
      this.$store.commit('vehicle/updateDownloadVideoHistoriesWidgetData', [])
      this.$store.commit('vehicle/updateDownloadVideoHistoriesInProgressFirstData', [])
      this.$store.commit('vehicle/updateLoadingDownloadVideoHistoriesWidget', false)
      this.$store.commit('vehicle/resetDownloadVideoPerItemStatus')
    },

    async startDownload(video) {
      if (this.isVideoDemo) {
        return
      }
      this.track('Click Video History Download', {
        license_plate: this.$store.state.vehicle.vehicleDetail.licensePlate,
        filename: `${video.mediaFilename}`,
      })
      if (video.url) {
        const link = document.createElement('a')
        link.href = video.url
        link.setAttribute('download', `${video.mediaFilename}`)
        link.click()
        link.remove()
      }
    },

    handleClickShowVideo(video) {
      if (this.isVideoDemo) {
        window.sessionStorage.setItem(
          'tv2VideoHistoryDemoData',
          JSON.stringify(this.$store.state.vehicle.downloadVideoHistoriesSuccessData)
        )
      }
      const isMenuTrackvision = this.hasAccessAll(['b3h-new-trackvision-menu:read'])
      const routeData = this.$router.resolve({
        name: isMenuTrackvision ? 'Video History Trackvision Download' : 'Video History 3 Download',
        query: {
          modalShowDownloadVideoId: video.downloadId,
          videoHistoryVehicleId: video.vehicle.id,
          ...(this.isVideoDemo ? { isDemo: true } : {}),
        },
      })
      window.open(routeData.href, '_blank')
    },

    checkVideoitemActiveInRanges(video, downloadPerItemActive) {
      return downloadPerItemActive.some((item) => {
        return (
          this.isBetweenDate(item.startTime, video.startTime, video.endTime) ||
          this.isBetweenDate(item.endTime, video.startTime, video.endTime) ||
          (video.startTime === item.startTime && video.endTime === item.endTime)
        )
      })
    },
  },
}
</script>
